import { configureStore } from '@reduxjs/toolkit';
import manifestReducer from '../slices/manifestSlice';

export default configureStore({
  reducer: {
    manifest: manifestReducer,
  },
});
